import React, { useCallback, useEffect, useMemo, useState } from "react";
import { HRMTable } from "../components/hrm_table";
import { useFaq } from "../../contexts/faq-context";
import HrmLoader from "../components/hrm_loader";
import NoData from "../../assets/No-Search-Result.png";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../modals/delete_model";
import { Plus } from "lucide-react";
import { ACTIONS } from "../../constants/actions";
import { adminFaqColumns } from "../../constants/data_columns/faq";
import { componentRoutes } from "../../constants/componentRoutes";
import FaqUpdate from "../modals/edit_faq";

const Faq = () => {
    const [faqList, setFaqList] = useState([]);
    const [isDeleteFormVisible, setDeleteFormVisible] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isFaqEditFormVisible, setFaqEditFormVisible] = useState(false);

    const { onLoadFaq, faq, faqLoader, onDeleteFaq } = useFaq();
    

    useEffect(() => {
        const fetchData = async () => {
            await onLoadFaq()
        };
        fetchData();
    }, [onLoadFaq]);

    useEffect(() => {
        if(faq?.length > 0) {     
        setFaqList(
            faq.map((item) => {
                return {
                    id: item.id,
                    question: item.question,
                    answer: item.answer
                }
            })
        );
    } else {
        setFaqList([]);
    }
    }, [faq]);

    const navigate = useNavigate();

    const handelAddFaq = async () => {
        navigate(componentRoutes.addFaq);
    }
      const handleDelete = async () => {
        if (!selectedId) return;
        
          const response = await onDeleteFaq(selectedId)
            if (response.code == 1) {
                setDeleteFormVisible(false);
                setSelectedId(null);
            }        
      };

      const onSelectAction = useCallback(
        (row, value) => {
            if (ACTIONS.DELETE === value) {
                setSelectedId(row.id);
                setDeleteFormVisible(true)

            } else if (ACTIONS.EDIT === value) {
                setSelectedRow(row);
                setFaqEditFormVisible(true);

            } else {
            }
        },
        []
    );

      const columns = useMemo(() => {
              return adminFaqColumns({ onSelectAction });
            }, [onSelectAction])

    useEffect(() => {
        if (!setFaqEditFormVisible) {
            setSelectedRow(null);
        }
        }, [isFaqEditFormVisible]);
    

return (
    <>
    <div className="col-span-12 md:order-1 xl:col-span-8 2xl:col-span-6">
        <h5 className="mb-2">Faq</h5>
    </div>
    <div className="card">
    <div className="card-body">
    <div className="mb-2">
    <div className="grid grid-cols-1 gap-5 lg:grid-cols-12 items-center">
                
    <div className="xl:col-span-2 xl:col-start-11">
    <div className="ltr:lg:text-right rtl:lg:float-left">
    <button
        type="button"
        onClick={handelAddFaq}
        className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
        ><Plus className="inline-block size-4"/>
        <span className="align-middle">Add Faq</span>
        </button>
    </div>
  </div>
 </div>
</div>
    { faqLoader
         ? (<HrmLoader />) : faqList.length > 0 ? (
            <HRMTable data={faqList} columns={columns} />
        ) : (
            <img src={NoData} alt="No Data Available" className="w-200 h-200 mx-auto" />
        ) 
    }
    
    {isDeleteFormVisible && 
        <DeleteModal
            isVisible={isDeleteFormVisible}
            onClose={() => {
                setDeleteFormVisible(false)
                setSelectedId(null);
            }}
            onConfirm={handleDelete}
            title="Delete Faq"
            description="Are you sure you want to delete this faq?"
        />
    }
    {isFaqEditFormVisible && 
        <FaqUpdate 
            isFaqEditFormVisible={isFaqEditFormVisible}
            onClose={() => {
                setFaqEditFormVisible(false)
                setSelectedId(null)
            }}
            initialValues={selectedRow}
         />
    }
    </div>
    </div>
    </>
)
};

export default Faq;